import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions, Router, NavigationEnd } from '@angular/router';
import { AppAuthGuard, PermissionGuard } from './guards';
import { AuthService } from './services';
import {
  LoginComponent,
  DashboardComponent,
  HelpComponent,
  NoAccessComponent,
  NotFoundComponent,
  RegistrationComponent,
  UserProfileComponent,
  UserEditComponent,
  OrganizationListComponent,
  OrganizationProfileComponent,
  OrganizationEditComponent,
  OrganizationCreateComponent,
  ExportComponent,
  ImportComponent,
  KaspiPriceCreateComponent,
  KaspiPriceListComponent,
  KaspiPriceEditComponent,
  AttributesListComponent,
  FileCreateComponent,
  FilesListComponent,
  ProductCreateComponent,
  ProductEditComponent,
  ProductProfileComponent,
  ProductsListComponent,
  IntegrationComponent,
  KaspiSettingsComponent,
  PresetEditComponent
} from './components/pages';
import { SettingsComponent } from './components/pages/settings/settings.component';
import { PresetCreateComponent } from './components/pages/presets/preset-create/preset-create.component';
import { NotificationsListComponent } from './components/pages/notifications/notifications-list/notifications-list.component';
import { NotificationProfileComponent } from './components/pages/notifications/notification-profile/notification-profile.component';
import { PublicApiComponent } from './components/pages/integrations/public-api/public-api.component';
import { OzonSettingsComponent } from './components/pages/integrations/ozon/settings/ozon-settings/ozon-settings.component';
import { OzonProductListComponent } from './components/pages/integrations/ozon/ozon-product-list/ozon-product-list.component';
import { OzonSendProductsComponent } from './components/pages/integrations/ozon/ozon-send-products/ozon-send-products.component';
import { MarkingSettingsComponent } from './components/pages/integrations/marking/settings/marking-settings/marking-settings.component';
import { MarkingProductListComponent } from './components/pages/integrations/marking/products/marking-product-list/marking-product-list.component';
import { MarkingProductProfileComponent } from './components/dialog/integrations/marking-product-profile/marking-product-profile.component';
import { SubscriptionsCreateComponent } from './components/pages/subscriptions/subscriptions-create/subscriptions-create.component';
import { FileEditComponent } from './components/pages/files/file-edit/file-edit.component';
import { OrgsIntegrationComponent } from './components/pages/integrations/orgs-integration/orgs-integration.component';
import { SpecificationsCreateComponent } from './components/pages/specifications/specifications-create/specifications-create.component';
import { SpecificationsEditComponent } from './components/pages/specifications/specifications-edit/specifications-edit.component';



const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: '/login' },
  { path: 'login', component: LoginComponent },
  { path: 'registration', component: RegistrationComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AppAuthGuard] },
  { path: 'help', component: HelpComponent, canActivate: [AppAuthGuard] },
  // { path: 'import', component: ImportComponent, canActivate: [AppAuthGuard] },
  {
    path: 'import',
    children: [
      { path: '', pathMatch: 'full', component: ImportComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'IMPORTS' } }
    ]
  },
  {
    path: 'export',
    children: [
      { path: '', pathMatch: 'full', component: ExportComponent, canActivate: [AppAuthGuard] },
      {
        path: 'integrations',
        children: [
          {
            path: 'kaspi',
            children: [
              { path: '', pathMatch: 'full', component: KaspiPriceListComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
              { path: 'create', component: KaspiPriceCreateComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
              { path: 'edit/:id', component: KaspiPriceEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
            ]
          },
          {
            path: 'ozon',
            children: [
              { path: '', pathMatch: 'full', component: OzonProductListComponent, canActivate: [AppAuthGuard] },
              { path: 'create', component: OzonSendProductsComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_OZON' } },
              // { path: 'edit/:id', component: KaspiPriceEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
            ]
          },
          {
            path: 'marking',
            children: [
              { path: '', pathMatch: 'full', component: MarkingProductListComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_MARKING' } },
              { path: 'profile', component: MarkingProductProfileComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_MARKING' } },
              // { path: 'create', component: KaspiPriceCreateComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
              // { path: 'edit/:id', component: KaspiPriceEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
            ]
          },
          // {
          //   path: 'metro',
          //   children: [
          //     { path: '', pathMatch: 'full', component: MarkingProductListComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_MARKING' } },
          //     { path: 'profile', component: MarkingProductProfileComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_MARKING' } },
          //     // { path: 'create', component: KaspiPriceCreateComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
          //     // { path: 'edit/:id', component: KaspiPriceEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'INTEGRATION_KASPI' } },
          //   ]
          // }
        ]
      }
    ]
  },
  {
    path: 'integration',
    children: [
      { path: '', pathMatch: 'full', component: IntegrationComponent, canActivate: [AppAuthGuard] },
      {
        path: 'settings',
        children: [
          //{ path: '', pathMatch: 'full', component: KaspiPriceListComponent, canActivate: [AppAuthGuard] },
          { path: 'kaspi', component: KaspiSettingsComponent, canActivate: [AppAuthGuard] },
          { path: 'ozon', component: OzonSettingsComponent, canActivate: [AppAuthGuard] },
          { path: 'marking', component: MarkingSettingsComponent, canActivate: [AppAuthGuard] },
          { path: 'public-api', component: PublicApiComponent, canActivate: [AppAuthGuard] },
          { path: 'orgs', component: OrgsIntegrationComponent, canActivate: [AppAuthGuard] },
        ]
      }
    ]
  },
  {
    path: 'users',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'profile' },
      // { path: '', pathMatch: 'full', component: UserListComponent, canActivate: [AppAuthGuard] },
      { path: 'profile', component: UserProfileComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'USERS' } },
      // { path: 'create', component: UserCreateComponent, canActivate: [AppAuthGuard] },
      { path: 'edit/:id', component: UserEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'USERS' } }
    ]
  },
  {
    path: 'organizations',
    children: [
      { path: '', pathMatch: 'full', component: OrganizationListComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'ORGANIZATIONS' } },
      { path: 'profile/:id', component: OrganizationProfileComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'ORGANIZATIONS' } },
      { path: 'create', component: OrganizationCreateComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'ORGANIZATIONS' } },
      { path: 'edit/:id', component: OrganizationEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'ORGANIZATIONS' } }
    ]
  },
  {
    path: 'files',
    children: [
      { path: '', pathMatch: 'full', component: FilesListComponent, canActivate: [AppAuthGuard], data: { module: 'FILES' } },
      // { path: 'profile/:id', component: OrganizationProfileComponent, canActivate: [AppAuthGuard] },
      { path: 'create', component: FileCreateComponent, canActivate: [AppAuthGuard], data: { module: 'FILES' } },
      { path: 'edit/:id', component: FileEditComponent, canActivate: [AppAuthGuard], data: { module: 'FILES' } }
    ]
  },
  {
    path: 'products',
    children: [
      { path: '', pathMatch: 'full', component: ProductsListComponent, canActivate: [AppAuthGuard], data: { module: 'PRODUCTS' } },
      { path: 'profile/:id', component: ProductProfileComponent, canActivate: [AppAuthGuard], data: { module: 'PRODUCTS' } },
      { path: 'create', component: ProductCreateComponent, canActivate: [AppAuthGuard], data: { module: 'PRODUCTS' } },
      { path: 'edit/:id', component: ProductEditComponent, canActivate: [AppAuthGuard], data: { module: 'PRODUCTS' } }
    ]
  },
  {
    path: 'attributes',
    children: [
      { path: '', pathMatch: 'full', component: AttributesListComponent, canActivate: [AppAuthGuard] }, //PermissionGuard], data: { module: 'ATTRIBUTES'}
      // { path: 'profile/:id', component: ProductProfileComponent, canActivate: [AppAuthGuard] },
      // { path: 'create', component: AttributeCreateComponent, canActivate: [AppAuthGuard] },
      // { path: 'edit/:id', component: ProductEditComponent, canActivate: [AppAuthGuard] }
    ]
  },
  {
    path: 'presets',
    children: [
      { path: '', pathMatch: 'full', component: PresetCreateComponent, canActivate: [AppAuthGuard] }, //PermissionGuard], data: { module: 'ATTRIBUTES'}
      // { path: 'profile/:id', component: ProductProfileComponent, canActivate: [AppAuthGuard] },
      { path: 'create', component: PresetCreateComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'PRESETS' } },
      { path: 'edit/:id', component: PresetEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'PRESETS' } }
    ]
  },
  {
    path: 'subscriptions',
    children: [
      { path: '', pathMatch: 'full', component: PresetCreateComponent, canActivate: [AppAuthGuard] }, //PermissionGuard], data: { module: 'ATTRIBUTES'}
      // { path: 'profile/:id', component: ProductProfileComponent, canActivate: [AppAuthGuard] },
      { path: 'create', component: SubscriptionsCreateComponent, canActivate: [AppAuthGuard] }, //, PermissionGuard], data: { module: 'SUBSCRIPTIONS' }
      // { path: 'edit/:id', component: PresetEditComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'SUBSCRIPTIONS' } }
    ]
  },
  {
    path: 'settings',
    children: [
      { path: '', pathMatch: 'full', component: SettingsComponent, canActivate: [AppAuthGuard], data: { module: 'SETTINGS' }}, //PermissionGuard], data: { module: 'ATTRIBUTES'}
      // { path: 'profile/:id', component: ProductProfileComponent, canActivate: [AppAuthGuard] },
      // { path: 'create', component: ProductCreateComponent, canActivate: [AppAuthGuard] },
      // { path: 'edit/:id', component: ProductEditComponent, canActivate: [AppAuthGuard] }
    ]
  },
  {
    path: 'notifications',
    children: [
      { path: '', pathMatch: 'full', component: NotificationsListComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'NOTIFICATIONS' }}, 
      { path: 'profile/:id', component: NotificationProfileComponent, canActivate: [AppAuthGuard, PermissionGuard], data: { module: 'NOTIFICATIONS' } },
      // { path: 'create', component: ProductCreateComponent, canActivate: [AppAuthGuard] },
      // { path: 'edit/:id', component: ProductEditComponent, canActivate: [AppAuthGuard] }
    ]
  },
  {
    path: 'specifications',
    children: [
      // { path: '', pathMatch: 'full', component: SpecifictationsManagmentComponent, canActivate: [AppAuthGuard], data: { module: 'NOTIFICATIONS' }}, 
      { path: 'create', component: SpecificationsCreateComponent, canActivate: [AppAuthGuard] },
      { path: 'edit/:id', component: SpecificationsEditComponent, canActivate: [AppAuthGuard] }
    ]
  },
  { path: 'no-access', component: NoAccessComponent },
  { path: '**', component: NotFoundComponent },
];

const config: ExtraOptions = {
    useHash: false,
    onSameUrlNavigation: 'reload'
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [AppAuthGuard]
})
export class AppRoutingModule {

  constructor(
    private authService: AuthService,
    // private permissionService: PermissionService,
    private router: Router
  ) {

    // Проверка страниц доступных только если пользователь не авторизован
    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd) {
        
        this.authService.checkingOpenPages(event);
      }
    });
  }
}
